import { createApp } from 'vue'
import GoogleSignInPlugin from 'vue3-google-signin'
import App from './App.vue'
import { setupI18n } from './locales'
import { setupAssets, setupComponent, setupMixin, setupScrollbarStyle } from './plugins'
import { setupStore } from './store'
import { setupRouter } from './router'
import '@/styles/naiveui-variables.css'
import '@/styles/components/index.css'

function setupAppViewportHeightVar() {
  let lastHeight = 0

  const setAppHeight = () => {
    const height = Math.round(window.visualViewport?.height ?? window.innerHeight)
    if (!height || height === lastHeight)
      return
    lastHeight = height
    document.documentElement.style.setProperty('--app-height', `${height}px`)
  }

  setAppHeight()

  window.addEventListener('resize', setAppHeight, { passive: true })
  window.addEventListener(
    'orientationchange',
    () => {
      setTimeout(setAppHeight, 150)
    },
    { passive: true },
  )

  window.visualViewport?.addEventListener('resize', setAppHeight, { passive: true })
}

async function bootstrap() {
  const app = createApp(App)

  // TEMP: build/debug info – remove after environment verification
  // console.log('ENV:', import.meta.env.MODE)
  // console.log('BUILD_ID:', import.meta.env.VITE_BUILD_ID)
  // console.log('BUILD_TIME:', import.meta.env.VITE_BUILD_TIME)

  setupAssets()

  setupAppViewportHeightVar()

  setupScrollbarStyle()

  setupStore(app)

  setupI18n(app)

  await setupRouter(app)

  setupComponent(app)

  setupMixin(app)
  app.use(GoogleSignInPlugin, {
    clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID,
  })

  app.mount('#app')
}

bootstrap()
